import { render } from "./TheBikeTypeDetails.vue?vue&type=template&id=89260b4c"
import script from "./TheBikeTypeDetails.vue?vue&type=script&lang=js"
export * from "./TheBikeTypeDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__